<template>
    <div class="p-3">
        <!-- Begin Page Content -->
        <div class="medical-records">
            <div class="row">
                <div class="col-12 mb-4">
                    <div class="card border-0">
                        <div class="mb-3 d-flex justify-content-end">
                            <router-link to="/prescription" class="d-inline-flex align-items-center whiteButton"><span class="plusCircle mb-0 bg-white mr-2"><feather class="mr-1" type="chevron-left"></feather></span> Back to Prescription list</router-link>
                        </div>
                        <!-- <div class="card-header border-0 bg-white d-flex justify-content-end">
                            <router-link to="/qr-prescription" class="btn btn-gray scan-button"><i class="icon icon-mobile-phone"></i>Continue with Mobile</router-link>
                        </div> -->
                        <div class="card-body p-0">
                            <div class="bg-white border-radius-5 p-5">
                                <div class="row no-gutters justify-content-center">
                                    <div class="col-12 col-md-6 text-center upload-reports">
                                        <form action="" method="post" enctype="multipart/form-data" id="UploadDocuments">
                                            <div class="drag-drop">
                                                <input type="file" name="document" @change="onFileChange($event.target.files[0])" ref="documemnts" v-validate="'required'"/>
                                                <i class="icon icon-upload-reports"></i>
                                                <h3 class="mt-4">Drag and Drop Files Files To Upload</h3>
                                                <p>you can do this anytime without clicking upload</p>
                                                <span class="d-block">or</span>
                                                <button type="submit" class="btn btn-blue attach">Attach File</button>
                                                <p class="text-center alert alert-danger mt-3" v-if="submitted" v-for="error in errors.collect('document')">{{ error }}</p>
                                            </div>
                                            <div class="preview" v-if="fileName">
                                                <div class="file-upload d-flex justify-content-between align-items-center border-radius-5 border-1 bg-white mt-3 mb-4 p-2">
                                                    <div class="image-upload d-flex align-items-center">
                                                        <figure class="mb-0"><img src="../../../../static/website/images/report.png" alt="" /></figure>
                                                        <h5>{{fileName}}</h5>
                                                    </div>
                                                    <div class="icons d-fle">
                                                        <!-- <a href="#"><i class="icon icon-check-bold"></i></a> -->
                                                        <a href="javascript:void(0)" class="close-icon" @click="removeDocument()"><i class="icon icon-close"></i></a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="input-group mt-3 mb-4">
                                                <input placeholder="prescription" type="text" v-model="prescription" name="prescription" class="btPlace" v-validate="'required|max:100'" :class="{ 'is-invalid': submitted && errors.has('prescription') }" ref="prescriptionInput" style="opacity: 1; height:40px; position:relative" />
                                                <p class="error" v-if="submitted" v-for="error in errors.collect('prescription')">{{ error }}</p>
                                            </div>
                                            <a href="javascript:void(0)" class="btn btn-blue" :class="[{'mt-3': fileName == ''}]" @click.prevent="addPrescription" >Continue</a>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End of Page Wrapper -->
</template>
<script>
    export default {
        name: "upload-prescription",
        data() {
            return {
                pageTitle: this.$options.name,
                pageLoader: false,
                submitted : false,
                prescription : '',
                fileName : '',
            };
        },
        methods:{
            onFileChange(event){
                var fileData =  event;
                this.fileName=fileData.name;
                
            },
            removeDocument(){
                this.fileName = ''
                this.$refs.documemnts.value = ''
            },
            addPrescription(){
                const _that = this
                let Upload = document.getElementById('UploadDocuments');
                let form_name = new FormData(Upload);
                let form_data_get = form_name.get('document');
                _that.submitted = true;
                // form_name.append("user_id" , parseInt(_that.$route.query.id));
                 // form_name.append("prescription" , _that.prescription);
                _that.$validator.validate().then(valid => {
                    if (valid) {
                        let inputJson = {
                            'globalParams' : {
                                "form" : form_name,
                            } ,'localParams' : {'parameter' : _that,'type' :'form'}
                        }   
                        if(_that.$route.query.prescription_id){
                            form_name.append("prescription_id" , parseInt(_that.$route.query.prescription_id));
                        }else{
                            form_name.append("prescription_id" ,'');
                        }
                        _that._runpatientAddEditPrescription(inputJson)
                    }
                });
            },
            reset(){
                this.submitted = false
                this.fileName = ''
            }
        },
        created(){
           this.pageName('Drug Interaction Checker')
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/website/prescription/upload-prescription.vue